import apiClient from '../apiClient';
import { GET_ACCOMODATION_ITEM_BY_SERVICE_TYPE_ID_URL } from '../apiUrl';

const getAccomodationItemByServiceTypeApi = Id => {
  return apiClient.get(GET_ACCOMODATION_ITEM_BY_SERVICE_TYPE_ID_URL(Id));
};

export default getAccomodationItemByServiceTypeApi;
